import * as React from 'react';
import { Dispatch } from 'react-redux';
import { Translate } from 'react-redux-i18n';

import { StoreState } from '../../../reducers';
import { Api } from '../../../typings/api';
import Utils from '../../../utils';
import UserAgentUtils from '../../../utils/userAgent';
import { StyledShareButton, ShareButtonLabel } from './styles';
import { ShareOrigin, share } from '../../../containers/Share/actions';
import Tooltip from '../../Tooltip';
import { getMenuButtonIcon } from '../../../utils/menuManager';

interface ShareButtonProps {
	shareOrigin: ShareOrigin;
	galleryConfig: Api.Config;
	dispatch: Dispatch<StoreState>;
	isNativeShare: boolean;
	sharedItems: Api.DriveItem[];
	sharedNotesIds: number[];
	iconSrc?: string;
	icon?: string;
	label?: string;
	isInBottomBar?: boolean;
	isInMenuBar?: boolean;
}

const ShareButton = ({
	sharedItems,
	sharedNotesIds,
	iconSrc,
	label,
	isInBottomBar,
	isInMenuBar,
	dispatch,
}: ShareButtonProps) => {
	const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
		dispatch(share(sharedItems, sharedNotesIds));
	};

	const tooltipId = Utils.generateId();
	const isTooltipDisplayed = UserAgentUtils.isDesktop() && !isInBottomBar;

	return (
		<StyledShareButton
			className="ShareButton"
			isInBottomBar={isInBottomBar}
			isInMenuBar={isInMenuBar}
			onClick={handleClick}
			data-tip={true}
			data-for={tooltipId}
		>
			{isInMenuBar
				? getMenuButtonIcon(iconSrc, 'iconset_uprez_share')
				: Utils.getSvgIcon('iconset_uprez_share')
			}
			{isInBottomBar &&
				<ShareButtonLabel>
					<Translate value={'messages.share_my_selection'}/>
				</ShareButtonLabel>
			}
			{isTooltipDisplayed &&
				<Tooltip id={tooltipId} text={label || 'messages.share'} />
			}
		</StyledShareButton>
	);
};

export { ShareButtonProps };
export default ShareButton;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Share/ShareButton/index.tsx